import { motion } from "framer-motion";
import { SlidersHorizontal } from "lucide-react";

const LangMark = () => (
  <div className="flex items-center gap-2 font-heading font-bold text-terra leading-none" aria-label="English and Arabic">
    <span className="text-3xl">A</span>
    <span className="text-2xl text-line">/</span>
    <span className="text-3xl">ع</span>
  </div>
);

const points = [
  {
    mark: <LangMark />,
    title: "Speaks their language, literally",
    body: "The AI assistant takes orders in multiple languages, meeting every caller however they naturally communicate, so nothing gets lost on the line.",
  },
  {
    icon: SlidersHorizontal,
    title: "Built around your kitchen, not the other way around",
    body: "Generic restaurant software makes your staff bend to fixed workflows. This adapts to how your restaurant already operates, matching the way you already take and make orders.",
  },
];

const MarketGrowth = () => {
  return (
    <section className="relative py-24 md:py-32 border-t border-line bg-surface" data-testid="market-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          <span className="text-terra font-heading text-sm font-semibold tracking-widest uppercase">Where the plates are headed</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter text-cream leading-[1.05]">
            The fastest-growing kitchens deserve the smartest front door.
          </h2>
          <p className="mt-8 text-base sm:text-lg text-sand leading-relaxed">
            Halal dining is one of the fastest-growing corners of food service. The U.S. halal food
            market is projected to grow from <span className="text-cream font-medium">$733.6 billion in 2025</span> to{" "}
            <span className="text-cream font-medium">$1.6 trillion by 2034</span>, according to IMARC Group. That kind of
            growth means one thing for your phone: more calls, more customers, and more ways they
            expect to be understood.
          </p>
        </motion.div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-6">
          {points.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group border border-line bg-ink p-8 flex flex-col justify-between min-h-[240px] hover:border-terra/50 transition-colors duration-500"
              data-testid={`market-point-${i}`}
            >
              <div className="h-8 flex items-center text-terra">
                {p.mark ? p.mark : <p.icon className="w-8 h-8" strokeWidth={1.5} />}
              </div>
              <div>
                <h3 className="font-heading text-xl sm:text-2xl font-medium text-cream mb-3">{p.title}</h3>
                <p className="text-sand leading-relaxed">{p.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketGrowth;
